import React from 'react';




const Skills = () => {
    return ( 
        <div className="skillsWrapper">
            <i class="fab fa-html5"><p>HTML</p></i>
            <i class="fab fa-css3-alt"><p>CSS</p></i>
            <i class="fab fa-sass"><p>SASS</p></i>
            <i class="fab fa-js-square"><p>JavaScript</p></i>
            <i class="fab fa-react"><p>React</p></i>
            <i class="fab fa-github"><p>Git</p></i>
        </div>
     );
}
 
export default Skills;